"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureFlagEnabledSaga = isFeatureFlagEnabledSaga;
exports.isSSEProbabilitiesUpdateOptimizationEnabled = isSSEProbabilitiesUpdateOptimizationEnabled;
const effects_1 = require("redux-saga/effects");
const utils_1 = require("./utils");
const types_1 = require("./types");
const selectors_1 = require("./selectors");
function* isFeatureFlagEnabledSaga(featureFlagName) {
    const featureFlags = yield (0, effects_1.select)(selectors_1.selectFeatureFlags);
    return (0, utils_1.getIsFeatureFlagEnabled)({
        featureFlags,
        featureFlagName,
    });
}
// TODO: PLAT-1313 Remove after release
function* isSSEProbabilitiesUpdateOptimizationEnabled() {
    const featureFlags = yield (0, effects_1.select)(selectors_1.selectFeatureFlags);
    return (0, utils_1.getIsFeatureFlagEnabled)({
        featureFlags,
        featureFlagName: types_1.EFeatureFlags.SSE_PROBABILITIES_UPDATE_OPTIMIZED,
    });
}
//# sourceMappingURL=saga.js.map